import React, { useState, useCallback } from "react";
import { MessageDTO } from "utils/helpers/models/shared/message.dto";
import useStore from "hooks/useStore";
import AmbassadorChatWindow from "./AmbassadorChatWindow";
import AmbassadorMessageInput from "./AmbassadorMessageInput";

const AmbassadorCommunity = ({ eventId }: { eventId: number }) => {
  const [messages, setMessages] = useState<MessageDTO[]>([]);
  const { getUserProfilePic } = useStore();
  const userProfilePic = getUserProfilePic();

  const handleMessageAppended = useCallback((m: MessageDTO) => {
    setMessages((prev) => [...prev, m]);
  }, []);

  // Check if the event has ended - you can add this logic based on your event data structure
  const isEventEnded = false; // Add your event end date check logic here

  return (
    <div className="flex flex-col h-[calc(100vh-200px)] min-h-0 relative bg-white">
      <AmbassadorChatWindow
        eventId={eventId}
        messages={messages}
        setMessages={setMessages}
        userProfilePic={userProfilePic}
        isEventEnded={isEventEnded}
      />

      {eventId && (
        <>
          {isEventEnded ? (
            <div className="flex items-center justify-center p-6 flex-shrink-0">
              <div className="text-center text-gray-600 bg-gray-100 rounded-lg p-4 max-w-full">
                <p className="text-base sm:text-lg font-medium break-words">
                  Community conversation are now archived. Grateful to
                  have shared this space with you.
                </p>
              </div>
            </div>
          ) : (
            <div className="flex-shrink-0">
              <AmbassadorMessageInput
                eventId={eventId}
                messages={messages}
                setMessages={setMessages}
                onMessageAppended={handleMessageAppended}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AmbassadorCommunity;